import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import useCart from "hooks/useCart";
import {
  concatenateAddressComponents,
  renderPriceWithSymbol,
} from "utils/commonMethods";
import { VendingMachineIcon } from "constants/icons";
import "containers/Checkout/CheckoutVmCard/CheckoutVmCard.css";
import { removeDuplicatesFromProductsJson } from "utils/commonMethods";

//Renders vending machine address and products user is buying.
function CheckoutVmCard({ componentTexts, itemsUnableToDispense }) {
  const { currentCartItems, cartTotalPrice, totalDiscountPrice } = useCart();
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const cartCouponDetails = useSelector(
    (state) => state.cartReducer.couponDetails
  );
  const vendingMachineItems = useSelector(
    (state) => state.vmStockReducer.items
  );
  const minifiedVmItems = removeDuplicatesFromProductsJson(
    vendingMachineItems,
    "iUID"
  );

  let minifiedCartItems = currentCartItems.map((ele) => ({
    ...ele.item,
    ...ele,
    stk: minifiedVmItems.find((element) => ele.item.iUID === element.iUID).stk, //find concatenated stock of each item
    item: null,
  }));

  //Returns product name with its quantity and final price.
  const boughtProducts = removeDuplicatesFromProductsJson(
    minifiedCartItems,
    "iUID",
    false
  );

  const finalProduct = boughtProducts.map((element) => {
    return {
      label: `${element.name} x ${element.quantity}`,
      price: element.val * element.quantity,
    };
  });

  return (
    <div className="checkout-page__vm-card outer-shadow">
      <div className="vm-card__vm-details">
        <div className="vm-details__icon">
          <i>
            <VendingMachineIcon />
          </i>
        </div>
        <div>
          <p className="vm-details__label">
            {componentTexts.checkout_vm_address_label}
          </p>
          <p className="vm-details__vm-name">{vendingMachineDetails.name}</p>
          <p className="vm-details__vm-address">
            {concatenateAddressComponents(vendingMachineDetails.location)}
          </p>
        </div>
      </div>
      <hr />
      <div className="checkout-page__products-overview">
        {finalProduct.map((product) => (
          <React.Fragment key={product.label}>
            <span className="checkout-page__product-overview">
              {product.label}
            </span>
            <span className="checkout-page__product-price">
              {renderPriceWithSymbol(product.price)}
            </span>
          </React.Fragment>
        ))}
        {itemsUnableToDispense && (
          <div className="checkout-page__items-cant-dispense">
            {componentTexts.error_invalid_items_prefix}
            <ul className="items-cant-dispense__list-items">
              {itemsUnableToDispense.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
            {componentTexts.error_invalid_items_suffix}
          </div>
        )}
      </div>
      <hr />
      <div className="checkout-page__cart-total">
        <div className="sub-head checkout-page__cart-sub-total-label">
          {componentTexts.checkout_vm_subtotal_label}
        </div>
        <span className="sub-head text-right checkout-page__cart-sub-total-price">
          {renderPriceWithSymbol(cartTotalPrice)}
        </span>
        {totalDiscountPrice > 0 && (
          <React.Fragment>
            <div className="sub-head checkout-page__cart-discount-label">
              {componentTexts.checkout_discount_label}
            </div>
            <span className="sub-head text-right checkout-page__cart-discount-price">
              -{renderPriceWithSymbol(totalDiscountPrice)}
            </span>
          </React.Fragment>
        )}
        {cartCouponDetails && (
          <React.Fragment>
            <div className="sub-head checkout-page__cart-discount-label">
              {componentTexts.checkout_coupon_label}
            </div>
            <span className="sub-head text-right checkout-page__cart-discount-price">
              -{renderPriceWithSymbol(cartCouponDetails.dVal)}
            </span>
          </React.Fragment>
        )}
      </div>
      <hr />
      <div className="checkout-page__cart-total">
        <div className="checkout-page__cart-total-label">
          {componentTexts.checkout_vm_total_label}
        </div>
        <span className="sub-head text-right checkout-page__cart-total-price">
          {renderPriceWithSymbol(
            cartTotalPrice - totalDiscountPrice - (cartCouponDetails?.dVal || 0)
          )}
        </span>
      </div>
    </div>
  );
}

CheckoutVmCard.propTypes = {
  componentTexts: PropTypes.object.isRequired,
  itemsUnableToDispense: PropTypes.arrayOf(PropTypes.string),
};

export default CheckoutVmCard;
